module.exports = __webpack_public_path__ + "static/media/marker-ne.656880e1.svg";